/**
 * Super Admin Auth Layout
 *
 * Simple centered layout for super admin authentication.
 */
import React from 'react';
import { Shield } from 'lucide-react';

export interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
}

export function AuthLayout({ children, title, subtitle }: AuthLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-900 p-4">
      {/* Logo */}
      <div className="mb-8 flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-500">
          <Shield className="h-7 w-7 text-white" />
        </div>
        <div>
          <span className="text-xl font-bold text-white">Respectly</span>
          <span className="ml-2 rounded bg-slate-700 px-2 py-0.5 text-xs font-medium text-slate-300">
            ADMIN
          </span>
        </div>
      </div>

      {/* Title */}
      <div className="mb-6 text-center">
        <h1 className="text-2xl font-bold text-white sm:text-3xl">{title}</h1>
        {subtitle && (
          <p className="mt-2 text-sm text-slate-400">{subtitle}</p>
        )}
      </div>

      {/* Content */}
      <div className="w-full max-w-md">
        {children}
      </div>

      {/* Footer */}
      <p className="mt-8 text-center text-xs text-slate-500">
        Super Admin Portal - Authorized Access Only
      </p>
    </div>
  );
}

export default AuthLayout;
